import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _RCE;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "import/no-unresolved": "warn" */
import React, { Component } from 'react';
import { arrayOf, bool, func, node, object, shape, exact, string, number } from 'prop-types';
import debounce from 'lodash/debounce';
import classNames from 'classnames';
import { jsx, Global } from '@instructure/emotion';
import CanvasRce from '@instructure/canvas-rce/es/rce/RCE';
import RCE5Renderer from '../RichContentRenderer';
import { mapQuizRcePropsToCanvasRceProps } from './rce5Utils';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import '!!style-loader!css-loader!mathlive/dist/mathlive-fonts.css'; // eslint-disable-line
import { withStyleOverrides, FormField } from '@instructure/quiz-common';
import { pickProps } from '@instructure/ui-react-utils';
var errorMessageType = 'error';
export var actsAsInputString = 'acts_as_input_';
var defaultDelayInMs = 100;
var defaultDebounceOptions = {
  leading: true,
  trailing: true
};
export var RCE5 = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_RCE = /*#__PURE__*/function (_Component) {
  function RCE5() {
    var _this;
    _classCallCheck(this, RCE5);
    _this = _callSuper(this, RCE5, arguments);
    _defineProperty(_this, "state", {
      isInputModeToggled: false
    });
    _defineProperty(_this, "initOnChange", function () {
      /*
      The null parameter in RCE4 was a native event,
      but it's not used application wise, and RCE5 not pass back to callback.
      */
      var onChange = function onChange(content) {
        return _this.props.onChange(null, {
          editorContent: content
        });
      };
      _this.debouncedHandlers.change = debounce(onChange, defaultDelayInMs, defaultDebounceOptions);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      return Object.values(_this.debouncedHandlers).forEach(function (handler) {
        return handler.flush();
      });
    });
    _defineProperty(_this, "handleContentChange", function (content) {
      return _this.debouncedHandlers.change(content);
    });
    _defineProperty(_this, "handleInputModeToggle", function () {
      return _this.setState({
        isInputModeToggled: true
      });
    });
    /* istanbul ignore next */
    _defineProperty(_this, "handleOnBlur", function (e) {
      _this.setState({
        isInputModeToggled: false
      });
      var editorContent;
      try {
        // our best bet for getting up to date content is to get it from the Editor directly...
        editorContent = e.target.getContent();
      } catch (_unused) {
        // ...but it is not always available as the target
        // in this case, we fall back to the the content from prop
        editorContent = _this.props.defaultContent;
      }
      if (editorContent) {
        _this.props.onBlur(e, {
          editorContent: editorContent
        });
      }
    });
    /* istanbul ignore next */
    _defineProperty(_this, "handleEditorInit", function (tinyEditorInstance) {
      if (tinyEditorInstance && _this.props.autoFocus) {
        // Note: This is a temporary workaround for a Safari focus issue.
        // This will be handled by the RCX team in the future. The related work is tracked in
        // https://instructure.atlassian.net/browse/RCX-2881
        requestAnimationFrame(function () {
          var _tinyEditorInstance$r, _tinyEditorInstance$r2, _tinyEditorInstance$r3, _tinyEditorInstance$r4;
          (_tinyEditorInstance$r = tinyEditorInstance.rceWrapper) === null || _tinyEditorInstance$r === void 0 || (_tinyEditorInstance$r2 = _tinyEditorInstance$r.focus) === null || _tinyEditorInstance$r2 === void 0 || _tinyEditorInstance$r2.call(_tinyEditorInstance$r);
          (_tinyEditorInstance$r3 = tinyEditorInstance.rceWrapper) === null || _tinyEditorInstance$r3 === void 0 || (_tinyEditorInstance$r3 = _tinyEditorInstance$r3.editor) === null || _tinyEditorInstance$r3 === void 0 || (_tinyEditorInstance$r3 = _tinyEditorInstance$r3.iframeElement) === null || _tinyEditorInstance$r3 === void 0 || (_tinyEditorInstance$r4 = _tinyEditorInstance$r3.focus) === null || _tinyEditorInstance$r4 === void 0 || _tinyEditorInstance$r4.call(_tinyEditorInstance$r3);
        });
      }
      if (tinyEditorInstance !== null && tinyEditorInstance !== void 0 && tinyEditorInstance.selection) {
        tinyEditorInstance.selection.select(tinyEditorInstance.getBody(), true);
        tinyEditorInstance.selection.collapse(false);
      }
      tinyEditorInstance.dom.setAttrib(tinyEditorInstance.dom.select('body'), 'role', 'application');
      var screenreaderText = tinyEditorInstance.rceWrapper.iframe.title;
      tinyEditorInstance.dom.setAttrib(tinyEditorInstance.dom.select('body'), 'aria-label', screenreaderText);
    });
    _defineProperty(_this, "useQuizzesRCE", function () {
      var _this$props = _this.props,
        defaultContent = _this$props.defaultContent,
        placeholder = _this$props.placeholder,
        rendererEnhancement = _this$props.rendererEnhancement,
        ltiApps = _this$props.ltiApps,
        featureFlags = _this$props.featureFlags;
      var invalidStyle = _this.invalid ? _this.props.styles.invalidRceInput : {};
      var placeholderStyle = placeholder && !defaultContent ? _this.props.styles.placeholderRceInput : {};
      var customStyles = _objectSpread(_objectSpread(_objectSpread({}, _this.props.styles.actAsInput), invalidStyle), placeholderStyle);
      var canvasToolId = ltiApps === null || ltiApps === void 0 ? void 0 : ltiApps.canvasToolId;
      return jsx("div", {
        role: "textbox",
        tabIndex: "0",
        className: "asciimath2jax_ignore",
        "aria-label": t('Rich Content Editor'),
        "data-automation": "sdk-rce",
        onClick: _this.handleInputModeToggle,
        onKeyUp: _this.handleInputModeToggle,
        "aria-invalid": _this.invalid ? 'true' : undefined
      }, jsx(FormField, Object.assign({}, pickProps(_this.props, FormField.propTypes), {
        id: _this.id
      }), jsx(RCE5Renderer, {
        content: defaultContent || placeholder,
        customStyles: customStyles,
        enhancementProps: rendererEnhancement,
        canvasToolId: canvasToolId,
        featureFlags: featureFlags
      })));
    });
    _defineProperty(_this, "useCanvasRCE", function () {
      return jsx(FormField, Object.assign({}, pickProps(_this.props, FormField.propTypes), {
        id: _this.id
      }), jsx("div", {
        css: _this.props.styles.uiFont,
        className: classNames({
          'invalid-rce': _this.invalid,
          'readonly-rce': _this.props.readOnly
        }),
        "data-automation": "sdk-rce-opened",
        "data-testid": "RichContentInput",
        "aria-invalid": _this.invalid ? 'true' : undefined
      }, _this.renderCanvasRce()));
    });
    // We sometimes use a customized version of the RCE for a better user experience (QUIZ-9484)
    // when the user is EDITING the content, not just viewing it.
    _defineProperty(_this, "render", function () {
      var showInputMode = _this.props.actsAsInput && !_this.state.isInputModeToggled;
      return jsx(React.Fragment, null, jsx(Global, {
        styles: _this.props.styles.globalStyles
      }), showInputMode ? _this.useQuizzesRCE() : _this.useCanvasRCE());
    });
    _this.debouncedHandlers = {};
    _this.initOnChange();
    return _this;
  }
  _inherits(RCE5, _Component);
  return _createClass(RCE5, [{
    key: "id",
    get: function get() {
      var _this$props2 = this.props,
        actsAsInput = _this$props2.actsAsInput,
        textareaId = _this$props2.textareaId;
      return "".concat(actsAsInput ? actsAsInputString : '').concat(textareaId);
    }
  }, {
    key: "invalid",
    get: function get() {
      return this.props.messages.findIndex(function (message) {
        return message.type === errorMessageType;
      }) >= 0;
    }
  }, {
    key: "renderCanvasRce",
    value: function renderCanvasRce() {
      return jsx(CanvasRce, mapQuizRcePropsToCanvasRceProps(this.props, {
        onBlur: this.handleOnBlur,
        onContentChange: this.handleContentChange,
        onInit: this.handleEditorInit
      }));
    }
  }]);
}(Component), _defineProperty(_RCE, "displayName", 'RCE5'), _defineProperty(_RCE, "componentId", "Quizzes".concat(_RCE.displayName)), _defineProperty(_RCE, "propTypes", {
  autoFocus: bool,
  textareaId: string.isRequired,
  defaultContent: string,
  defaultRceSettings: shape({
    enabled: bool,
    font: string,
    fontSize: string
  }),
  height: number,
  stem: string,
  actsAsInput: bool,
  placeholder: string,
  label: node.isRequired,
  isRequired: bool,
  messages: arrayOf(shape({
    type: string.isRequired
  })),
  readOnly: bool,
  onChange: func,
  onFocus: func,
  onBlur: func,
  editorOptions: shape({
    spellCheck: bool.isRequired,
    wordCount: bool.isRequired
  }),
  rcsProps: shape({
    canvasUserId: string.isRequired,
    contextType: string.isRequired,
    contextId: string.isRequired,
    resourceId: string,
    resourceType: string,
    rcsHost: string.isRequired,
    rcsJwt: string.isRequired,
    rcsJwtRefreshFn: func.isRequired,
    canvasConfig: object.isRequired
  }),
  rendererEnhancement: shape({
    canvasOrigin: string
  }),
  ltiApps: exact({
    canvasToolId: string,
    editorButtons: arrayOf(object),
    ltiIframeAllowances: arrayOf(string)
  }),
  featureFlags: shape({
    displayOldLinks: bool
  }),
  styles: object
}), _defineProperty(_RCE, "defaultProps", {
  autoFocus: false,
  defaultContent: '',
  stem: '',
  height: null,
  actsAsInput: false,
  placeholder: '',
  isRequired: false,
  messages: [],
  readOnly: false,
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  editorOptions: null,
  rcsProps: null,
  rendererEnhancement: null,
  ltiApps: null,
  featureFlags: null
}), _RCE)) || _class);
export default RCE5;